import { FC, Fragment } from "react";
import React from "react";
import {
    FormControl,
    Popover,
    InputAdornment,
    makeStyles,
    createStyles,
    Grid,
} from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import { InfoBoxRemovalBuildingOccupationDate } from "../core/InfoBox";
import { CalendarWeekChooser } from "../core/CalendarWeekChooser";
import moment from "moment";
import { LabledTextField } from "../core/LabledTextField";
import { CalendarIcon } from "../core/icons/Icons";

const useFormControlStyles = makeStyles(() =>
    createStyles({
        container: {
            flexDirection: "row",
            alignItems: "space-evenly",
        },
        p: {
            marginBottom: 0,
        },
    }),
);

export const KWFormatter = (date: number): string => moment.unix(date).format("[KW]ww YYYY");
export const KWFormatterLong = (date: number): string =>
    moment.unix(date).format("[KW]ww / [ab] DD. MMM YYYY");

export const RemovalDateForm: FC = () => {
    const classes = useStyles();
    const formControlStyles = useFormControlStyles();
    const { values, setValues } = useFormModel<ChangeNames.REMOVAL_DATE>();

    const from = values.removalDate.value?.from;

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 0 }}>
                    Wann soll die Demontage durchgeführt werden?
                </h4>
                <p className={[classes.p, formControlStyles.p].join(" ")}>
                    Geben Sie eine Kalenderwoche an, ab der die Demontage durchgeführt werden soll.
                </p>
                <InfoBoxRemovalBuildingOccupationDate />
                <Grid className={formControlStyles.container} container spacing={2}>
                    <Grid item>
                        <FormControl component="fieldset" style={{ display: "flex" }}>
                            <h4 className={classes.h4} style={{ marginBottom: 0, marginLeft: 24 }}>
                                Ab *
                            </h4>
                            <PopupState variant="popover" popupId="CalenderWeekChooserPopoverFrom">
                                {(popupState) => (
                                    <div>
                                        <LabledTextField
                                            {...bindTrigger(popupState)}
                                            endAdornment={
                                                <InputAdornment position="start">
                                                    <CalendarIcon />
                                                </InputAdornment>
                                            }
                                            value={
                                                from ? KWFormatter(from) : "Bitte Datum auswählen"
                                            }
                                            error={values.removalDate.error ? true : false}
                                        />
                                        <Popover
                                            {...bindPopover(popupState)}
                                            anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "center",
                                            }}
                                            transformOrigin={{
                                                vertical: "top",
                                                horizontal: "center",
                                            }}
                                        >
                                            <CalendarWeekChooser
                                                firstDay={moment()}
                                                isCurrentWeekSelectable={false}
                                                resultCallback={(result) => {
                                                    setValues((state) => {
                                                        state.removalDate.value = {
                                                            to: null,
                                                            ...state.removalDate.value,
                                                            from: result.unix(),
                                                        };
                                                    });
                                                    popupState.close();
                                                }}
                                            />
                                        </Popover>
                                    </div>
                                )}
                            </PopupState>
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        </Fragment>
    );
};
